import { JsonConverter, JsonCustomConvert } from "json2typescript";

@JsonConverter
export class TypeEnumConverter implements JsonCustomConvert<TypeEnum>{
    serialize() { }
    deserialize(data: any): TypeEnum {
        switch (data) {
            case 'TYPE_L':
            case 'TYEP_L':
                {
                    return TypeEnum.TYPE_L;
                }
            case 'TYPE_C':
            case 'TYEP_C':
                {
                    return TypeEnum.TYPE_C;
                }
            default:
                {
                    return TypeEnum.TYPE_L;
                }
        }
    }
}


export enum TypeEnum {
    TYPE_L = "TYPE_L",
    TYPE_C = "TYPE_C",
}
